import { Input, TextArea } from "semantic-ui-react";

export default [
  {
    "control": Input,
    "placeholder": "AXXXX- This value is auto-generated by the system.",
    "name": "cn_id",
    "label": "Personal ID",
    "required": false,
    "readOnly": true
  },
  [{
    "control": Input,
    "placeholder": "Name",
    "name": "name",
    "label": "Name",
    "required": true
  },
  {
    "control": Input,
    "placeholder": "Surname",
    "name": "surname",
    "label": "Surname",
    "required": true
  }],
  {
    "control": Input,
    "placeholder": "Email",
    "name": "email",
    "label": "Email",
    "required": true,
  },
  {
    "control": TextArea,
    "placeholder": "Description...",
    "name": "description",
    "label": "Description",
    "required": false,
    "maxLength": 50
  },
  // {
  //   "control": Select,
  //   "placeholder": "Select one...",
  //   "name": "employee_type",
  //   "label": "Employee Type",
  //   "search": true,
  //   "required": true,
  // }
  // ! AEP-136
];